<template>
    <v-dialog
      v-model="dialog"
      max-width="500px"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      transition="dialog-bottom-transition"
      persistent
    >
      <template v-slot:activator="{ on }">
        <v-btn class="secondary mt-2 mb-3" depressed block large v-on="on">{{label}}</v-btn>
      </template>
      <v-card>
      <v-toolbar dark flat color="primary">
        <v-toolbar-title v-if='loading'>Uploading...</v-toolbar-title>
        <v-toolbar-title v-else>{{label}}</v-toolbar-title>
      </v-toolbar>
      <v-container>
        <v-layout row v-if="error">
        <v-flex xs12>
          <app-alert @dismissed="onDismissed" :text="error.message" :color="error.colour"></app-alert>
        </v-flex>
      </v-layout>
        <v-layout column pt-0>
          <v-flex v-if='!loading'>
            <p>1) Upload an existing document or use your camera. </p>
            <v-btn depressed block color="accent" @click="onPickFile">Add</v-btn>
            <input
            type="file"
            style="display:none;"
            ref="fileInput"
            accept="images/*"
            @change="onFilePicked">
          </v-flex>
          <v-flex v-if='loading' class="text-xs-center">
            <v-progress-linear
            background-color="primary"
            v-model="progress"
            color="secondary"
            ></v-progress-linear>
            <span class="title">{{parseInt(progress)}}%</span>
          </v-flex>
          <v-flex pt-3 v-if='!loading'>
            <p>2) Enter a name for this document. </p>
            <v-text-field
              name="documentName"
              label="Name"
              id="documentName"
              placeholder=" "
              v-model="documentName"
              required></v-text-field>
              <v-chip
              v-for="item in quickClicks"
              :key='item'
              @click='quickClick(item)'>{{item}}</v-chip>
          </v-flex>
        </v-layout>
        <v-layout row wrap pt-5 v-if='!loading'>
          <v-flex xs12>
            <v-btn
              depressed
              :disabled="loading"
              color="primary"
              @click="closeDialog()">Close</v-btn>
              <v-btn depressed color="secondary" @click="addDocument" :disabled="!readyForSubmit || loading" :loading="loading">
                Save
                  <span slot="loader" class="custom-loader">
                    <v-icon light>cached</v-icon>
                  </span>
              </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    </v-dialog>
</template>

<script>
// import firebase from 'firebase'

export default {
  name: 'AddDocument',
  data () {
    return {
      dialog: false,
      documentName: '',
      documentObject: '',
      quickClicks: [ 'Car Insurance Certificate', 'Insurance Details', 'Policy Document', 'Scene Picture' ]
    }
  },
  props: {
    label: {
      type: String,
      default: 'Add document'
    }
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    },
    user () {
      return this.$store.getters.user.id
    },
    progress () {
      return this.$store.getters.progress
    },
    readyForSubmit () {
      if (this.documentObject !== '' && this.documentName !== '') {
        return true
      }
      return false
    }
  },
  methods: {
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    quickClick (quickName) {
      if (quickName !== '') {
        this.documentName = quickName
      }
    },
    onPickFile () {
      this.$refs.fileInput.click()
    },
    onFilePicked (event) {
      // takes the file input's image
      const files = event.target.files
      // check a file was actually chosen
      if (event.target.files.length === 0) {
        return console.log('oops no file')
      }
      // get the filename
      let filename = files[0].name
      // console.log('filesize', files[0].size)
      // quick validation
      // check filesize
      if (files[0].size > 10 * 1024 * 1024) { // < 10meg
        return alert('File too large, please add a file under 10 megabytes and try again.')
      }
      // check has extension
      if (filename.lastIndexOf('.') <= 0) {
        return alert('Please add a valid file.')
      }
      if (this.documentName === '') {
        this.documentName = filename
      }
      // read theimage to base64 only when finished load
      // and add to data imageUrl
      // const fileReader = new FileReader()
      // fileReader.addEventListener('load', () => {
      //   this.imageUrl = fileReader.result
      // })
      // fileReader.readAsDataURL(files[0])
      // also store the image itself
      this.documentObject = files[0]
    },
    closeDialog () {
      // blank the variables for next time
      this.documentName = ''
      this.documentObject = ''
      this.dialog = false
    },
    addDocument () {
      this.$store.dispatch('clearError')
      this.$store.commit('setLoading', true)

      this.$store.dispatch('addDocument', { documentName: this.documentName, documentObject: this.documentObject }).then(response => {
        // file added succesfully so..
        // log stats
        this.$ga.event('Documents', this.label, 'File')
        // fire a notification
        this.$store.dispatch('addNotification', { text: 'File added.', type: 'success' })
        // close the dialog
        this.closeDialog()
        // stop the loader anim
        this.$store.commit('setLoading', false)
        // reset the progress counter
        this.$store.commit('setProgress', 0)
      }).catch(error => {
        // An error happened.
        // show the error
        this.$store.commit('setError', error)
        // stop the loader
        this.$store.commit('setLoading', false)
        console.log('error', error)
      })
    }
  }

}
</script>
